var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataVaultInactive = function SvgDataVaultInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.519,
    height: 48.519
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "data-vault-inactive_svg__a",
    width: 48.519,
    height: 48.519,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Data Vault"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#data-vault-inactive_svg__a)",
    transform: "translate(.002 .002)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#858585",
    stroke: "#fff",
    "data-name": "Ellipse 251",
    transform: "rotate(-1 435.29 -570.334)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.76 13.26h-15a1.5 1.5 0 0 0-1.5 1.5v10a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-10a1.5 1.5 0 0 0-1.5-1.5m-.5 11h-14v-9h14Z",
    "data-name": "Secondary Layer",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.51 27.76h-2.25l-.5-1.5h-3l-.5 1.5h-2.25a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h8.5a.75.75 0 0 0 0-1.5m-11.25-12.5v9h14v-9Z",
    "data-name": "Primary Layer"
  })))));
};
export { SvgDataVaultInactive as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDguNTE5IiBoZWlnaHQ9IjQ4LjUxOSIgdmlld0JveD0iMCAwIDQ4LjUxOSA0OC41MTkiPgogIDxkZWZzPgogICAgPGZpbHRlciBpZD0iRWxsaXBzZV8yNTEiIHg9IjAiIHk9IjAiIHdpZHRoPSI0OC41MTkiIGhlaWdodD0iNDguNTE5IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8ZmVPZmZzZXQgZHk9IjMiIGlucHV0PSJTb3VyY2VBbHBoYSIvPgogICAgICA8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIzIiByZXN1bHQ9ImJsdXIiLz4KICAgICAgPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMC4xNjEiLz4KICAgICAgPGZlQ29tcG9zaXRlIG9wZXJhdG9yPSJpbiIgaW4yPSJibHVyIi8+CiAgICAgIDxmZUNvbXBvc2l0ZSBpbj0iU291cmNlR3JhcGhpYyIvPgogICAgPC9maWx0ZXI+CiAgPC9kZWZzPgogIDxnIGlkPSJEYXRhX1ZhdWx0IiBkYXRhLW5hbWU9IkRhdGEgVmF1bHQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MTIuODM4IC0yNDcuMDY4KSI+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLCAwLCAwLCAxLCA2MTIuODQsIDI0Ny4wNykiIGZpbHRlcj0idXJsKCNFbGxpcHNlXzI1MSkiPgogICAgICA8ZyBpZD0iRWxsaXBzZV8yNTEtMiIgZGF0YS1uYW1lPSJFbGxpcHNlIDI1MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAuMDIgNy41MSkgcm90YXRlKC0xKSIgZmlsbD0iIzg1ODU4NSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjEiPgogICAgICAgIDxjaXJjbGUgY3g9IjE0IiBjeT0iMTQiIHI9IjE0IiBzdHJva2U9Im5vbmUiLz4KICAgICAgICA8Y2lyY2xlIGN4PSIxNCIgY3k9IjE0IiByPSIxNC41IiBmaWxsPSJub25lIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICAgIDxnIGlkPSJJY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MjguNDM2IDI2MC4zMjgpIj4KICAgICAgPHBhdGggaWQ9IlNlY29uZGFyeV9MYXllciIgZGF0YS1uYW1lPSJTZWNvbmRhcnkgTGF5ZXIiIGQ9Ik03LjUtMTRoLTE1QTEuNSwxLjUsMCwwLDAtOS0xMi41djEwQTEuNSwxLjUsMCwwLDAtNy41LTFoMTVBMS41LDEuNSwwLDAsMCw5LTIuNXYtMTBBMS41LDEuNSwwLDAsMCw3LjUtMTRaTTctM0gtN3YtOUg3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC42NjIgMTQpIiBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwLjUiLz4KICAgICAgPHBhdGggaWQ9IlByaW1hcnlfTGF5ZXIiIGRhdGEtbmFtZT0iUHJpbWFyeSBMYXllciIgZD0iTTQuMjUuNUgyTDEuNS0xaC0zTC0yLC41SC00LjI1QS43NS43NSwwLDAsMC01LDEuMjUuNzUuNzUsMCwwLDAtNC4yNSwyaDguNWEuNzUuNzUsMCwwLDAsMC0xLjVaTS03LTEydjlIN3YtOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguNjYyIDE0KSIgZmlsbD0iI2ZmZiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";